import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import InputText from '../../Atoms/InputText';
import InputFile from '../../Atoms/InputFile';
import Button from '../../Atoms/Button';
import Badge from '../../Atoms/Badge';
import List from '../../Molecules/List';
import svg from '../../../constants/svg';

function ApplicationForm() {
  return (
    <div className="w-full rounded-xl bg-white p-7 @container">
      <div className="mb-6 flex w-full flex-col gap-3.5">
        <Title as="h3">Solliciteer direct</Title>
        <Text
          color="blue"
          weight={400}
          size="sm"
          font="circular"
          className="text-opacity-60"
        >
          <span>
            Interesse in deze vacature? Solliciteer nu!
            Twijfel je of je geschikt bent voor deze
            functie? Laat dan toch je gegevens achter. Dan
            kijken wij wat er mogelijk is. Je krijgt{' '}
            <b>binnen 1 uur</b> reactie.
          </span>
        </Text>
      </div>
      <form
        action="#!"
        className="relative z-20 grid gap-3.5"
      >
        <div className="flex flex-col items-center justify-between gap-3.5 @md:flex-row">
          <InputText label="Voornan" className="w-full" />
          <InputText label="Achternan" className="w-full" />
        </div>
        <div className="flex flex-col items-center justify-between gap-3.5 @md:flex-row">
          <InputText
            label="Jouw e-mailadres"
            className="w-full"
          />
        </div>
        <div className="flex flex-col items-center justify-between gap-3.5 @md:flex-row">
          <InputText
            label="Jouw teelefoonnummber"
            className="w-full"
          />
        </div>
        <div className="flex flex-col items-center justify-between gap-3.5 @md:flex-row">
          <InputFile placeholder="Upload CV" />
        </div>

        <div className="-mb-3.5 flex flex-col-reverse items-center justify-between gap-3.5 @md:-mb-7 @md:flex-row">
          <Badge
            text="We gaan vertrouwelijk met jouw gegevens om
"
            icon="lock-keyhole-regular"
            size="xs"
            color="indigo-light"
          />
          <Button
            text="Verstuur je sollicitatie!"
            color="accent"
            className="w-full items-center justify-center @md:w-auto"
            shadow
          />
        </div>
      </form>
      <div className="relative z-10 -mx-7 -mb-7 rounded-xl bg-sl-indigo px-7 pt-10 pb-7 md:py-10">
        <div className="pointer-events-none absolute top-1/2 right-1/4 hidden translate-x-3/4 -translate-y-1/2 opacity-25 lg:block xl:translate-x-1/2">
          {svg.applicationFormArrow}
        </div>
        <List
          animateMobile
          listItems={[
            <Text
              color="white"
              font="circular"
              weight={700}
              key={1}
            >
              <span className="text-xs md:text-sm lg:text-base">
                Binnen <b>1 uur</b> reactie
              </span>
            </Text>,
            <Text
              color="white"
              font="circular"
              weight={700}
              key={2}
            >
              <span className="text-xs md:text-sm lg:text-base">
                Geen klik? Wij vinden de{' '}
                <b>passende baan</b>
              </span>
            </Text>,
            <Text
              color="white"
              font="circular"
              weight={700}
              key={3}
            >
              <span className="text-xs md:text-sm lg:text-base">
                Monteurs beoordelen ons met een <b>9.3</b>
              </span>
            </Text>
          ]}
          color="white"
          icon="checkmark"
        />
      </div>
    </div>
  );
}

export default ApplicationForm;
